import { jsx as i, jsxs as v } from "@emotion/react/jsx-runtime";
import { useRef as s, useMemo as T } from "react";
import { StyledElement as j, Container as E } from "./MenuItem.styled.js";
import { Checkbox as L } from "../Checkbox/index.js";
import { Radio as N } from "../Radio/index.js";
import { Text as S } from "../Text/index.js";
import { Tooltip as K } from "../Tooltip/index.js";
import { useMenuItemKeyboardNavigation as U } from "./hooks/useMenuItemKeyboardEvent.js";
import { MENU_ITEM as _ } from "../../constants/accessibilityAttributes.js";
const J = ({
  dataTrackId: p,
  name: d,
  value: M,
  onChange: x,
  showTick: C = !1,
  type: e = "radio",
  checked: o = !1,
  disabled: r = !1,
  children: n,
  className: y,
  isError: a,
  onFocus: I,
  onBlur: R,
  tooltip: b,
  id: g,
  label: m,
  color: f = "primary",
  ref: l
}) => {
  const u = s(null), t = s(null), c = (k) => {
    t.current && k?.target !== t.current && !r && t.current.click();
  };
  U({
    ref: l ?? u,
    onClick: c,
    disabled: r
  });
  const h = T(() => j(e === "radio" ? N : L), [e]);
  return /* @__PURE__ */ i(K, { text: b, children: /* @__PURE__ */ v(E, { onClick: c, className: y, "data-checked": o || !1, "data-disabled": r, "data-error": a, ref: l ?? u, "data-navigation": _, color: f, tabIndex: 0, children: [
    /* @__PURE__ */ i(h, { type: e, dataTrackId: p, name: d, value: M, onChange: x, showTick: C, checked: o, disabled: r, error: a, onFocus: I, onBlur: R, hasLabel: !!m, id: g, ref: t, "data-error": a, color: f, children: /* @__PURE__ */ i(S, { variant: o ? "bodyMSemibold" : "bodyMMedium", as: "span", oneLine: !0, children: m }) }),
    typeof n == "function" ? n({
      checked: o,
      disabled: r
    }) : n
  ] }) });
};
export {
  J as MenuItem
};
